import { render, staticRenderFns } from "./chartVisits.vue?vue&type=template&id=08702ba8&scoped=true&"
import script from "./chartVisits.vue?vue&type=script&lang=js&"
export * from "./chartVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08702ba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08702ba8')) {
      api.createRecord('08702ba8', component.options)
    } else {
      api.reload('08702ba8', component.options)
    }
    module.hot.accept("./chartVisits.vue?vue&type=template&id=08702ba8&scoped=true&", function () {
      api.rerender('08702ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/overview/chartVisits.vue"
export default component.exports